import type { CmsImageData } from '@/services/cms/models/CmsImageData';

export function urlForCmsAsset(image: CmsImageData | string): string {
    const url = typeof image === 'string' ? image : image.link;
    return url;
}
